import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Auth0WebHeader from '@auth0/web-header';
import Auth0ContactForm from 'auth0-contact-form';
import { connectToStores } from 'fluxible-addons-react';
import AbStore from '../../client/stores/AbStore';
import ApplicationStore from '../../client/stores/ApplicationStore';
import { headerVariant } from '../../lib/abVariants';
import { login, signup } from '../../client/action/navigateAuthentication';
import AuthDropdown from './AuthDropdown';

class Header extends Component {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.metricsLib = window.metricsLib;
    this.createContactForm();
  }

  trackEvent(trackingEvent) {
    return () => this.metricsLib.track(trackingEvent, getMetricsInfo('Auth'));
  }

  createContactForm() {
    this.contactForm = new Auth0ContactForm({
      onModalOpen() {
        this.metricsLib.track('open:talk-to-sales');
      },
      onFormSuccess(metricsData) {
        this.metricsLib.track('register:lead:talk-to-sales-modal', metricsData);
        this.metricsLib.track('sent:talk-to-sales', metricsData);
      },
      onFormFail(metricsData) {
        this.metricsLib.track('fail:register:lead:talk-to-sales-modal', metricsData);
        this.metricsLib.track('fail-sent:talk-to-sales', metricsData);
      }
    });
  }

  render() {
    const { isAuthenticated, user, winningVariant } = this.props;

    const props = {
      className: this.props.fullWidth ? 'header-full-width' : '',
      theme: this.props.theme,
      talkToSalesButtonLink: '',
      talkToSalesButtonOnClick: () => this.contactForm.show({ includePhoneField: true })
    };

    if (isAuthenticated) {
      props.loginButtonEnable = false;
      props.signupButtonEnable = false;
      props.userProfile = <AuthDropdown { ...user.profile } />;
    } else {
      props.loginButtonLink = '/docs/auth/login';
      props.loginButtonOnClick = () => this.context.executeAction(login);
      props.signupButtonOnClick = () => this.context.executeAction(signup);
    }

    return <Auth0WebHeader getAbVariantHeader={() => winningVariant} {...props} />;
  }
}

Header.propTypes = {
  theme: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  fullWidth: PropTypes.bool,
  domainUrlSignup: PropTypes.string,
  winningVariant: PropTypes.string,
  user: PropTypes.object
};

export default connectToStores(Header,
  [
    AbStore
  ],
  (context) => {
    const appStore = context.getStore(ApplicationStore);
    const abStore = context.getStore(AbStore);

    return {
      winningVariant: abStore.getWinningVariant(headerVariant)
    };
  }
);
